<template>
  <div :class="[`col-sm-6 col-lg-${col} mb-4 card-item-wrap`, { 'card-chat-open': chatOpen }]">
    <div
      class="block-4 text-center border card-item"
      :class="{ 'card-item--inactive': isExpired || disabled, 'card-item--topped': isTopped }"
    >
      <template v-if="isOwner && !isExpired && this.user.tariff_plan.topping !== 0">
        <div class="card-toolbar card-toolbar-top" v-tooltip="btnToppedTooltip">
          <a class="btn btn-owner-tool" :class="{ disabled: !canBeTopped }" href="#" @click.prevent="propagate">
            <i class="icon icon-bullhorn text-primary" aria-hidden="true"></i>
          </a>
        </div>
      </template>

      <a :href="`/produkt/${product.slug}`" @click.prevent="redirect(`/produkt/${product.slug}`)">
        <figure class="block-4-image">
          <div class="card-image" :style="styleImage" :title="product.title"></div>
          <label v-if="isOwner" class="card-status badge badge-light">{{ product.status }}</label>
          <label
            v-if="isOwner"
            class="card-status badge badge-secondary"
            @click.prevent.stop="extendValidity"
            v-tooltip="'Prodloužit platnost inzerátu'"
          >
            Platnost
            {{ user.tariff_plan.validity !== -1 ? moment(product.expires_at).format('D.MM.YYYY') : 'neomezená' }}
          </label>
          <label
            v-if="isOwner && isTopped"
            class="card-status badge badge-primary"
            @click.prevent="propagate"
          >
            Topován {{ moment(product.last_topped_at).format('D.MM. HH:mm') }}
          </label>
        </figure>
      </a>

      <div class="block-4-text p-4">
        <h3 class="card-title" :title="product.title">
          <p class="mb-0">
            <a :href="`/produkt/${product.slug}`" @click.prevent="redirect(`/produkt/${product.slug}`)">{{ product.title }}</a>
          </p>
        </h3>
        <p class="text-primary font-weight-bold">{{ product.price }} Kč</p>
      </div>

      <div class="card-toolbar">
        <product-like-btn
          :product="product"
          :can-be-favorited="canBeFavorited"
        />

        <template v-if="isOwner && !isExpired">
          <div class="dropdown dropup">
            <button class="btn btn-owner-tool" v-tooltip="'Nastavení'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="icon icon-cogs" aria-hidden="true"></i>
            </button>

            <div class="dropdown-menu dropdown-menu-right">
              <a v-if="canCancelReservation" class="dropdown-item text-primary" href="#" @click.prevent="cancelReservation">
                Zrušit rezervaci
              </a>
              <a v-if="product.status_key !== 'deactivated'" class="dropdown-item text-warning" href="#" @click.prevent="deactivate">
                Deaktivovat
              </a>
              <a v-if="canActivate" class="dropdown-item text-primary" href="#" @click.prevent="activate">
                {{ moment(product.expires_at).isAfter(moment()) ? 'Aktivovat' : 'Prodloužit' }}
              </a>
              <a class="dropdown-item text-danger" href="#" @click.prevent="destory">
                Odebrat
              </a>
            </div>
          </div>
          <a
            class="btn btn-owner-tool"
            :href="`/produkt/${product.slug}/edit`"
            v-tooltip="'Editovat'"
          >
            <i class="icon icon-pencil" aria-hidden="true"></i>
          </a>
          <a
            class="btn btn-owner-tool chat-notification"
            @click.prevent="chatOpen = !chatOpen"
            v-tooltip="'Chat'"
          >
            <i class="icon icon-chat" aria-hidden="true"></i>
            <span v-if="unreadMessagesCount > 0" class="badge badge-pill badge-warning">
              {{ unreadMessagesCount }}
            </span>
          </a>
        </template>
        <template
          v-if="
            this.isOwner &&
              moment().diff(this.product.expires_at, 'days') >= -7 &&
              canExtendValidity
          "
        >
          <a
            class="btn btn-owner-tool"
            href="#"
            @click.prevent="extendValidity"
            v-tooltip="'Prodloužit platnost'"
          >
            <i class="icon icon-alarm" aria-hidden="true"></i>
          </a>
        </template>
      </div>
    </div>

    <ProductCardChat
      v-if="chatOpen === true"
      :product-id="product.id"
      @close="chatOpen = false"
    ></ProductCardChat>
  </div>
</template>

<script>
import ProductCardChat from './ProductCardChat'

export default {
  components: {
    ProductCardChat
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    col: {
      type: Number | String,
      default: 4,
      required: false
    },
    isOwner: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      chatOpen: false,
      disabled: false
    }
  },
  computed: {
    styleImage() {
      const img = this.product.primary_image_small

      return img ? `background-image: url(${img});` : ''
    },
    location() {
      return window.location
    },
    isActive() {
      return this.product.active
    },
    isExpired() {
      return this.product.status_key === 'expired'
    },
    unreadMessagesCount() {
      let count = 0

      if (this.product.unread_messages) {
        return this.product.unread_messages.length
      }

      return count
    },
    canExtendValidity() {
      return (
        this.product.status_key !== 'sold' && this.product.status_key !== 'expired' &&
        this.product.extended_counter < this.user.tariff_plan.renewal &&
        $('#products-over-limit').length === 0 &&
        this.user.tariff_plan.renewal !== -1
      )
    },
    canActivate() {
      return (
        this.product.status_key === 'deactivated' &&
        $('#products-over-limit').length === 0
      )
    },
    canCancelReservation() {
      return this.product.status_key === 'reserved'
    },
    isTopped() {
      if (this.product.created_at === this.product.last_topped_at) {
        return false;
      }

      return true;
    },
    canBeTopped() {
      const lastToppedAt = moment(this.product.last_topped_at)
      const createdAt = moment(this.product.created_at)

      if (this.user.tariff_plan.topping === 0) {
        return false
      }

      if (lastToppedAt.isSame(createdAt)) {
        return true
      }

      return moment().subtract(this.user.tariff_plan.topping, 'days').isAfter(lastToppedAt)
    },
    canBeFavorited() {
      return this.isActive
        && this.user
        && this.user.tariff_plan.price > 0
        && !this.user.tariff_plan.manufacturer_features
    },
    btnToppedTooltip() {
      return this.canBeTopped ?
        'Topovat'
        : `Tento inzerát bude možné znovu topovat ${moment().add(this.user.tariff_plan.topping, 'days').from(moment(this.product.last_topped_at))}`
    }
  },
  mounted() {
    this.disabled = this.redirect() === false
  },
  methods: {
    redirect(href) {
      if (window.location.pathname === "/profil/oblibene") {
        if (this.user && !this.user.tariff_plan.description.includes('Oblíbené')) {
          return false;
        }
      }

      if (href) {
        window.location.href = href
      }
    },
    deactivate() {
      this.$swal({
        title: '',
        text: 'Opravdu chcete deaktivovat inzerát?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Deaktivovat',
        cancelButtonText: 'Zpět'
      }).then((result) => {
        if (result.value) {
          window.location.replace(`/produkt/${this.product.id}/deactivate`)
        }
      })
    },
    activate() {
      this.$swal({
        title: '',
        text: 'Opravdu chcete aktivovat inzerát?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: moment(this.product.expires_at).isAfter(moment()) ? 'Aktivovat' : 'Prodloužit',
        cancelButtonText: 'Zpět'
      }).then((result) => {
        if (result.value) {
          window.location.replace(`/produkt/${this.product.id}/activate`)
        }
      })
    },
    cancelReservation() {
      this.$swal({
        title: '',
        text: 'Opravdu chcete zrušit rezervaci?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Potvrdit zrušení rezervace',
        cancelButtonText: 'Zpět'
      }).then((result) => {
        if (result.value) {
          window.location.replace(`/produkt/${this.product.id}/cancel-reservation`)
        }
      })
    },
    destory() {
      this.$swal({
        title: '',
        text: 'Odstranit?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Odstranit',
        cancelButtonText: 'Zpět'
      }).then((result) => {
        if (result.value) {
          window.location.replace(`/produkt/${this.product.id}/destroy`)
        }
      })
    },
    extendValidity() {
      if (!this.canExtendValidity) {
        return
      }

      this.$swal({
        title: 'Prodloužit inzerát?',
        text: 'Přejete si prodloužit inzerát?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Prodloužit',
        cancelButtonText: 'Zrušit'
      }).then((result) => {
        if (result.value) {
          window.location.replace(`/produkt/${this.product.id}/extend`)
        }
      })
    },
    propagate() {
      if (!this.canBeTopped) {
        return
      }

      let text = ''

      if (this.isTopped) {
        text += `Produkt byl naposledy topován dne ${moment(this.product.last_topped_at).format(
          'DD.MM. HH:mm'
        )}. `
      }

      text += 'Přejete si topovat inzerát?'

      this.$swal({
        title: 'TOPovat inzerát?',
        text: text,
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'TOPovat',
        cancelButtonText: 'Zrušit'
      }).then((result) => {
        if (result.value) {
          window.location.replace(`/produkt/${this.product.id}/propagate`)
        }
      })
    }
  }
}
</script>
